/**
 * bu tab 类型
 * @export
 * @enum {number}
 */
export enum EnumOutagePosition {
  /** @name PC端 Portal顶端 */
  PC_PORTAL_TOP = 'PC_PORTAL_TOP',
  /** @name PC端 工作台顶端 */
  PC_WORK_TOP = 'PC_WORK_TOP',
  /** @name 移动端 顶端 */
  MOBILE_TOP = 'MOBILE_TOP',
}
